module.exports = __webpack_public_path__ + "static/media/gestioneContenuti.5d5e7144.png";